import {Stack, styled} from '@mui/material'

export const ContentWrapper = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '1rem',
}))
